// extracted by mini-css-extract-plugin
export var description = "style-module--description--c4488";
export var headline = "style-module--headline--e3243";
export var link = "style-module--link--6bafe";
export var section = "style-module--section--8c292";